<x-chartist [type]="'Bar'" [data]="overlappingBarData" [options]="overlappingBarOptions"
  [responsiveOptions]="overlappingResponsiveOptions" class="height-300">
</x-chartist>